<template>
  <div class="table-responsive">
    <h6 class="booking-details-title">Zbor: {{ item.label }}</h6>
    <table class="table table-sm text-center">
      <thead class="t-head thead-light text-center">
        <tr>
          <td>Zbor</td>
          <td>Nr. zbor</td>
          <td>Data</td>
          <td>Decolare</td>
          <td>Ora</td>
          <td>Aterizare</td>
          <td>Ora</td>
        </tr>
      </thead>
      <tbody>
        <template v-for="(j, jIndex) in item.flight_info.journeys">
          <template v-for="(leg, legIndex) in j">
            <tr :key="'j' + jIndex + 'leg' + legIndex">
              <td>{{ jIndex ? 'Intors' : 'Dus' }}</td>
              <td>{{ leg.airline }} {{ leg.flight }}</td>
              <td>{{ leg.date }}</td>
              <td>{{ leg.from_name }}</td>
              <td>{{ leg.depTime }}</td>
              <td>{{ leg.to_name }}</td>
              <td>{{ leg.arrTime }}</td>
            </tr>
          </template>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'FlightItemInfo',
  props: ['item']
}
</script>
